import React, { useReducer } from "react";
import PropTypes from "prop-types";

// Set up our reducer function to act on Previous and Next selections
function reducer(state, action) {
    switch (action.type) {
        case "AllLocationDtos":
            return {
                ...state,
                allLocationDtos: action.allLocationDtos
            };
        case "GuardianState":
            return {
                ...state,
                guardianState: action.guardianState
            };
        case "GradingProfiles":
            return {
                ...state,
                gradingProfiles: action.gradingProfiles
            };
        case "Lang":
            return {
                ...state,
                lang: action.lang
            };
        case "LocKey":
            return {
                ...state,
                locKey: action.locKey
            };
        case "OeActionControls":
            return {
                ...state,
                oeActionControls: action.oeActionControls
            };
        case "OeActiveDistrictWindow":
            return {
                ...state,
                oeActiveDistrictWindow: action.oeActiveDistrictWindow
            };
        case "OeDistrictWindows":
            return {
                ...state,
                oeDistrictWindows: action.oeDistrictWindows
            };
        case "OeSchoolYearKey":
            return {
                ...state,
                oeSchoolYearKey: action.oeSchoolYearKey
            };
        case "SaeActionControls":
            return {
                ...state,
                saeActionControls: action.saeActionControls
            };
        case "SchoolYearDto":
            return {
                ...state,
                schoolYearDto: action.schoolYearDto
            };
        case "SchoolYearKey":
            return {
                ...state,
                schoolYearKey: action.schoolYearKey
            };
        case "StudentAppObjects":
            return {
                ...state,
                studentAppObjects: action.studentAppObjects
            };
        case "StudentImageList":
            return {
                ...state,
                studentImageList: action.studentImageList
            };
        case "StudentInfoDto":
            return {
                ...state,
                studentInfoDto: action.studentInfoDto
            };
        case "StudentsFlag":
            return {
                ...state,
                studentsFlag: {
                    ...state.studentsFlag,
                    ...action.studentsFlag
                }
            };
        case "StudentsHomeSchooled":
            return {
                ...state,
                studentsHomeSchooled: action.studentsHomeSchooled
            };
        case "StudentsIc":
            return {
                ...state,
                studentsIc: action.studentsIc
            };
        case "StudentsOe":
            return {
                ...state,
                studentsOe: action.studentsOe
            };
        case "ThruDashboard":
            return {
                ...state,
                thruDashboard: action.thruDashboard
            };
        case "TimePeriods":
            return {
                ...state,
                timePeriods: action.timePeriods
            };
        case "Token":
            return {
                ...state,
                token: action.token
            };
        case "UserDetails":
            return {
                ...state,
                userDetails: action.userDetails
            };
        case "Username":
            return {
                ...state,
                username: action.username
            };
        default:
            return { token: null };
    }
}

// Set the count to 0
const initialState = { token: null, username: null };
// Create a counter context, initially storing the initialState
const GlobalContext = React.createContext(initialState);
// Create a counter-provider to pass down the
const ContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    return (
        /**
         * Pass an object with the current state and dispatch values as props
         * to the context provider and allow all children of <CounterProvider/>
         * component to have these context values
         */
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        <GlobalContext.Provider value={{ state, dispatch }}>{children}</GlobalContext.Provider>
    );
};

ContextProvider.propTypes = {
    children: PropTypes.node
};

ContextProvider.defaultProps = {
    children: null
};

export { GlobalContext, ContextProvider };
